import React from 'react';
import PropTypes from 'prop-types';

import Message from './Message';

const Modal = ({
  modal,
  closeModal,
  message,
  getTotalTasks,
  getCompletedTasks
}) => {
  if (modal) {
    return (
      <div className='modal' style={{ display: 'block' }} onClick={closeModal}>
        <div className='modal-content'>
          <Message
            message={message}
            getTotalTasks={getTotalTasks}
            getCompletedTasks={getCompletedTasks}
          />
          <button className='btnClose' onClick={closeModal}>
            okay
          </button>
        </div>
      </div>
    );
  }
  return null;
};

Modal.propTypes = {
  modal: PropTypes.bool.isRequired,
  openModal: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired
};

export default Modal;
